// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { UserRole } from '../app/shared/auth.roles';

export const environment = {
  production: false,
  buyUrl: 'https://1.envato.market/6NV1b',
  SCARF_ANALYTICS: false,
  adminRoot: '/app',
  apiUrl: 'https://api.coloredstrategies.com',
  defaultMenuType: 'menu-default',
  subHiddenBreakpoint: 1440,
  menuHiddenBreakpoint: 768,
  themeColorStorageKey: 'vien-themecolor',
  isMultiColorActive: true,
  defaultColor: 'light.blueolympic',
  isDarkSwitchActive: true,
  defaultDirection: 'ltr',
  themeRadiusStorageKey: 'vien-themeradius',
  isAuthGuardActive: true,
  defaultRole: UserRole.Admin,
  databaseName: '/TERCERA',
  firebase: {
    apiKey: "AIzaSyCEutNe6FtSY5kByB5UjdIhOUcMNjykOxQ",
    authDomain: "sgt-client.firebaseapp.com",
    databaseURL: "https://sgt-client-default-rtdb.firebaseio.com",
    projectId: "sgt-client",
    storageBucket: "sgt-client.appspot.com",
    messagingSenderId: "325208670237",
    appId: "1:325208670237:web:74756a25215823eab5c6f4"
  },

  url_api: "https://back.sgt-dmr.com.uy",
  api_version: "v1"
};
